import actionTypes from '../actions/actionTypes';

export const INITIAL_STATE = {
  data: [],
  loading: false,
  error: null,
  profiles: [],
  sorting: '',
  searchBy: '',
  filter: false,
  clients: [],
  productDetails: {},
};

const skuTrackers = (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case actionTypes.TRACKERS_LOADING:
      return {
        ...state,
        loading: true,
      };
    case actionTypes.TRACKERS_SUCCESS:
      return {
        ...state,
        data: payload.data,
        loading: false,
      };
    case actionTypes.TRACKERS_ERROR:
      return {
        ...state,
        error: payload,
        loading: false,
      };
    case actionTypes.TRACKERS_PROFILES_LOADING:
      return {
        ...state,
        loading: true,
      };
    case actionTypes.TRACKERS_PROFILES_SUCCESS:
      return {
        ...state,
        profiles: payload,
        clients: [],
        loading: false,
      };
    case actionTypes.TRACKERS_SET_SORTING:
      return {
        ...state,
        sorting: payload,
      };
    case actionTypes.TRACKERS_SET_SEARCHBY:
      return {
        ...state,
        searchBy: payload,
      };
    case actionTypes.TRACKERS_SET_FILTER_FLAG:
      return {
        ...state,
        filter: !state.filter,
      };
    case actionTypes.TRACKERS_SET_CLIENTS:
      return {
        ...state,
        clients: payload,
      };
    case actionTypes.TRACKERS_SET_PRODUCT_DETAILS:
      return {
        ...state,
        productDetails: payload,
        clients: payload?.cmdUris || [],
        profiles: [],
        loading: false,
      };

    case actionTypes.REMOVE_TRACKER_PROFILE: {
      const tempProfiles = [...state.profiles];
      const tempClients = [...state.clients];
      const profileIndex = tempProfiles.findIndex((val) => val.cmdUri === payload);
      const clientIndex = tempClients.indexOf(payload);
      if (profileIndex !== -1) tempProfiles.splice(profileIndex, 1);
      if (clientIndex !== -1) tempClients.splice(clientIndex, 1);
      return {
        ...state,
        profiles: tempProfiles,
        clients: tempClients,
      };
    }
    case actionTypes.REMOVE_TRACKER: {
      const tempData = [...state.data];
      const index = tempData.findIndex((val) => val.pimSku === payload);
      if (index !== -1) tempData.splice(index, 1);
      return {
        ...state,
        data: tempData,
      };
    }
    case actionTypes.RESTORE_TRACKERS_STATE: {
      return { ...state, ...payload };
    }
    default:
      return state;
  }
};

export default skuTrackers;
